import http from 'utils/http';
import {
  getCancelDataSetUrls,
  getChunkUrls,
  getChunksUrls,
  getCloneKnowledgeBaseUrl,
  getDataSetUrls,
  getDataSetsUrls,
  getKnowledgeBaseParserUrl,
  getKnowledgeBaseUrl,
  getKnowledgeBasesUrl,
  getRestartDataSetUrls,
  getRetrieveChunkUrl
} from './apiUrls';
import { KnowledgeBaseRequest, KnowledgeBaseResponse } from 'apis/business/types';
import { ChunkResponse, DatasetResponse, KnowledgeBaseParserResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getKnowledgeBases(
  workspaceId: string,
  searchText?: string | null
): Promise<{ data: KnowledgeBaseResponse[]; meta: MetaApiResponse }> {
  return http.get(getKnowledgeBasesUrl(workspaceId), { 'filter[name_cont]': searchText });
}

export function getKnowledgeBase(workspaceId: string, id: string): Promise<{ data: KnowledgeBaseResponse[] }> {
  return http.get(getKnowledgeBaseUrl(workspaceId, id));
}

export function deleteKnowledgeBase(workspaceId: string, id: string): Promise<{ data: KnowledgeBaseResponse[] }> {
  return http.delete(getKnowledgeBaseUrl(workspaceId, id));
}

export function createKnowledgeBase(
  workspaceId: string,
  payload: KnowledgeBaseRequest
): Promise<KnowledgeBaseResponse> {
  return http.post(getKnowledgeBasesUrl(workspaceId), payload);
}

export function updateKnowledgeBase(
  workspaceId: string,
  id: string,
  payload: KnowledgeBaseRequest
): Promise<KnowledgeBaseResponse> {
  return http.patch(getKnowledgeBaseUrl(workspaceId, id), payload);
}

export function cloneKnowledgeBase(workspaceId: string, id: number): Promise<KnowledgeBaseResponse> {
  return http.post(getCloneKnowledgeBaseUrl(workspaceId, id));
}

export function getKnowledgeBaseParser(): Promise<KnowledgeBaseParserResponse> {
  return http.get(getKnowledgeBaseParserUrl());
}

export function getDataSets(
  workspaceId: string,
  knowledgeBaseId: string,
  searchText: string | null,
  currentPage: number
): Promise<{ data: DatasetResponse[]; meta: MetaApiResponse }> {
  return http.get(getDataSetsUrls(workspaceId, knowledgeBaseId), {
    page: currentPage,
    'filter[name_cont]': searchText
  });
}

export function getDataSet(workspaceId: string, knowledgeBaseId: string, dataSetId: string): Promise<DatasetResponse> {
  return http.get(getDataSetUrls(workspaceId, knowledgeBaseId, dataSetId));
}

// TODO need to update the any for payload
export function createDataSet(workspaceId: string, knowledgeBaseId: string, payload: any): Promise<any> {
  return http.post(getDataSetsUrls(workspaceId, knowledgeBaseId), payload);
}

export function updateDataSet(
  workspaceId: string,
  knowledgeBaseId: string,
  dataSetId: string,
  payload: any
): Promise<any> {
  return http.put(getDataSetUrls(workspaceId, knowledgeBaseId, dataSetId), payload);
}

export function deleteDataSet(workspaceId: string, knowledgeBaseId: string, id: string): Promise<String> {
  return http.delete(getDataSetUrls(workspaceId, knowledgeBaseId, id));
}

export function cancelDataSet(workspaceId: string, knowledgeBaseId: string, id: string): Promise<String> {
  return http.put(getCancelDataSetUrls(workspaceId, knowledgeBaseId, id), {});
}

export function restartDataSet(workspaceId: string, knowledgeBaseId: string, id: string): Promise<String> {
  return http.put(getRestartDataSetUrls(workspaceId, knowledgeBaseId, id), {});
}

export function getRetrieveChunk(workspaceId: string, knowledgeBaseId: string, data: any): Promise<any> {
  return http.get(getRetrieveChunkUrl(workspaceId, knowledgeBaseId), {
    'knowledgebase[content]': data.content,
    'knowledgebase[similarity_threshold]': data.similarity_threshold,
    'knowledgebase[vector_similarity_weight]': data.vector_similarity_weight
  });
}

export function getChunks(
  workspaceId: string,
  knowledgeBaseId: string,
  datasetId: string,
  currentPage: number,
  searchText: string | null
): Promise<{ data: ChunkResponse[]; meta: MetaApiResponse }> {
  return http.get(getChunksUrls(workspaceId, knowledgeBaseId, datasetId), {
    'filter[content]': searchText,
    page: currentPage
  });
}

export function getChunk(
  workspaceId: string,
  knowledgeBaseId: string,
  dataSetId: string,
  chunkId: string
): Promise<ChunkResponse> {
  return http.get(getChunkUrls(workspaceId, knowledgeBaseId, dataSetId, chunkId));
}

export function createChunk(
  workspaceId: string,
  knowledgeBaseId: string,
  dataSetId: string,
  payload: KnowledgeBaseRequest
): Promise<ChunkResponse> {
  return http.post(getChunksUrls(workspaceId, knowledgeBaseId, dataSetId), payload);
}

export function updateChunk(
  workspaceId: string,
  knowledgeBaseId: string,
  dataSetId: string,
  chunkId: string,
  payload: KnowledgeBaseRequest
): Promise<ChunkResponse> {
  return http.put(getChunkUrls(workspaceId, knowledgeBaseId, dataSetId, chunkId), payload);
}

export function deleteChunk(
  workspaceId: string,
  knowledgeBaseId: string,
  dataSetId: string,
  chunkId: string
): Promise<String> {
  return http.delete(getChunkUrls(workspaceId, knowledgeBaseId, dataSetId, chunkId));
}
